import React, { useState } from 'react'
import { TextField } from '@runeffective/evo-design-system'
import css from './measurementInput.module.scss'

import { get } from 'lodash'
import { metric, toSqft, toSqm } from './measurement'

import { Flex } from '@ui'

import numeral from 'numeral'
import { useUser } from '@hooks'

export const Unit = ({ unit }: { unit: string }) => {
  if (metric(unit)) {
    return (
      <span>
        m<sup>2</sup>
      </span>
    )
  }
  return <span>sqft</span>
}

const MeasurementInput = ({
  disabled,
  value,
  onChange,
}: {
  disabled?: boolean
  value: number
  onChange: ({ target: {} }: { target: { value: number; name: string } }) => void
}) => {
  const [focused, setFocused] = useState<boolean>(false)
  const user = useUser()
  const unit = get(user, 'user.context.units', '')
  const n = numeral(metric(unit) ? toSqm(value) : value)
  const format = Number.isInteger(n.value()) ? '0,0' : '0,0.00'

  const getNumeralValue = (measureVal: any) => {
    const value = numeral(measureVal).value()
    const n = numeral(metric(unit) ? toSqm(value) : value)
    return n.value()
  }

  const regex = /\d+(?:\.|\.\d+)?/
  const onchange = ({ target: { name, value } }: { target: { name: any; value: any } }) => {
    if (value === '') {
      value = '0'
    }
    if (!regex.test(value)) {
      value = value.slice(value.length - 1)
    }

    const n = metric(unit) ? toSqft(value) : value

    // if (numeral(value).value() !== numeral(n).value())
    onChange({
      target: { name, value: value.endsWith('.') ? value : n },
    })
  }

  return (
    <Flex align="flex-start" justify="center" direction="column">
      <label htmlFor="measurements" style={{ fontSize: 14, transform: 'translateY(10%)' }}>
        Area ({<Unit unit={unit} />})
      </label>
      <TextField
        onBlur={() => {
          if (!value || Number.isNaN(numeral(value).value())) {
            setFocused(false)
            return
          }
          setFocused(false)
        }}
        onChange={(value: any) => onchange({ target: { name: 'measurement', value: value } })}
        onFocus={() => setFocused(true)}
        size="small"
        disabled={disabled}
        className={css.measureTextField}
        value={focused ? value.toString() : n.format(format)}
      />
    </Flex>
  )
}

export default MeasurementInput
